import { render, staticRenderFns } from "./SfOverlay.vue?vue&type=template&id=05a0e329&functional=true&"
import script from "./SfOverlay.vue?vue&type=script&lang=js&"
export * from "./SfOverlay.vue?vue&type=script&lang=js&"
import style0 from "./SfOverlay.vue?vue&type=style&index=0&id=05a0e329&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports